import messageResource from "../messageResource";

/*
 Intended to show tooltips with cause why user can not receive notification.
 */
export default function NoNotificationMessageParams(accessRight) {
    this.accessRight = accessRight;
    this.disabledMessageKey = "mail_notifications.users_selector.no_notification.disabled";
    this.noEmailMessageKey = "mail_notifications.users_selector.no_notification.no_email";
}

NoNotificationMessageParams.prototype.getDisabledMessage = function(user) {
    return messageResource.getMessage(this.disabledMessageKey, [user.formatNameFML()]);
};

NoNotificationMessageParams.prototype.getAccessRightMessage = function(user) {
    return (this.accessRight) ? this.accessRight.getNoNotificationAccessRightMessage(user) : null;
};

NoNotificationMessageParams.prototype.getNoEmailMessage = function(user) {
    return messageResource.getMessage(this.noEmailMessageKey, [user.formatNameFML()]);
};




// WEBPACK FOOTER //
// ./web/js/usersSelector/NoNotificationMessageParams.js